module.exports = __webpack_public_path__ + "img/thumbnail_CaliforniaSeaLion_j_normal.e22a461d.png";